export default __webpack_public_path__ + "8f3ba4dd13672375be09d34cb1a84c6a.png";